<template>
<v-card flat tile class='elevation-10' >
  <v-toolbar flat dense dark
    :extended='extended' >
    <template v-if='backPath' >
      <v-btn text small
        v-if='backPath' :to='backPath' >
        <v-icon>mdi-chevron-left</v-icon> Back
      </v-btn>
      <v-divider vertical />
    </template>
    <slot name="title" >
      <v-toolbar-title v-if='title' class='pl-2' >
        {{title}}
      </v-toolbar-title>
    </slot>
    <v-spacer ></v-spacer>
    <slot name="toolbar" ></slot>
    <template slot="extension" >
      <v-fab-transition>
        <v-btn
          v-if='withAdd'
          fab absolute bottom right small dark
          :key='subTitle'
          @click="$emit('add')"
          color='teal' >
          <v-icon >mdi-plus</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-breadcrumbs :items='crumbs' class='ml-0 pl-2' />
    </template>
    <v-btn small icon
      class='ml-2'
      v-if='withRefresh' :loading='loading'
      @click='$emit("refresh")' >
      <v-icon>mdi-replay</v-icon></v-btn>
  </v-toolbar>
  <slot name='request-status' >
    <request-status v-if='request && request.resource' :request='request' />
    <v-divider></v-divider>
  </slot>
  <slot ></slot>
  <v-footer >
    <v-breadcrumbs :items='crumbs' class='ml-0 pa-0' />
  </v-footer>
</v-card>
</template>
<script>
export default {
  name: 'Page',
  props: {
    title: { type: String, required: false },
    subTitle: { type: String, required: false },
    backPath: { type: String, required: false },
    crumbs: { type: Array, default: () => { return [] } },
    withRefresh: { type: Boolean, default: true },
    withAdd: { type: Boolean, default: false },
    extended: { type: Boolean, default: true },
    request: { type: Object, required: false }
  },
  computed: {
    loading () {
      return this.getObjectPath(this.request, 'loading', false)
    }
  }
}
</script>
